<template>
  <div class="quick-actions">
    <button @click="$emit('quick-save')" class="action-btn save-btn" title="Quick Save (Ctrl+S)">
      💾 Save
    </button>
    <button @click="$emit('add-note')" class="action-btn note-btn" title="Add Global Note">
      📝 Note
    </button>
    <button @click="$emit('request-help')" class="action-btn help-btn" title="Request Help">
      🆘 Help
    </button>
  </div>
</template>

<script>
export default {
  // Simple component for quick actions
}
</script>

<style scoped>
.quick-actions {
  display: flex;
  gap: 8px;
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #e9ecef;
}

.action-btn {
  flex: 1;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f8f9fa;
  cursor: pointer;
  font-size: 0.9em;
  transition: all 0.2s ease;
}

.action-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.save-btn:hover {
  background: #d4edda;
  border-color: #c3e6cb;
}

.note-btn:hover {
  background: #fff3cd;
  border-color: #ffeaa7;
}

.help-btn:hover {
  background: #f8d7da;
  border-color: #f5c6cb;
}
</style>